import { Component, OnInit } from '@angular/core';
import jsPDF from 'jspdf';
import { VehiclesService } from '../../../../shared/services/vehicles.service'; // AJUSTAR: servicio que tiene getVerificarPlaca
import { GpsService } from '../../../../shared/services/gps.service';
import { gpcGoogleService } from '../../../../shared/services/gpcGoogle.service';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { AdminSeafLoadingService } from '../../../../shared/services/adminseaf-loading.service';


const Swal = require('sweetalert2');

// ============================================================
// Constantes
// ============================================================
// Rutas de las imágenes en el bucket
//const rutaLogo = (nit: string | number): string => `${nit}/logos/logo.png`;
// Imágenes en assets: assets/images/logos/{nit}/{archivo}
const rutaAsset = (nit: string | number, archivo: string): string => `assets/images/logos/901458283/${archivo}`;

const ARCHIVO_MINTIC = 'mintic.png'; // AJUSTAR al nombre real del archivo
const ARCHIVO_SELLO = 'sello.png'; // AJUSTAR al nombre real del archivo

// Posición del sello respecto al inicio del bloque de firma (mm)
const SELLO = { dx: 55, dy: 10, maxW: 50, maxH: 50 };

// Firma del representante legal: se consulta con el NIT y la cédula del firmante,
// sin depender de la administración que esté cargada
const NIT_FIRMA = '901458283'; // AJUSTAR: NIT con el que está registrada la firma (sin puntos ni dígito de verificación)
// true = si no se puede cargar la firma, NO se genera el certificado
const FIRMA_OBLIGATORIA = true;

// Datos fijos de quien emite la certificación (texto del PDF modelo)
const EMISOR = {
  razonSocial: 'INGENIERIA Y DESARROLLO DE SOFTWARE A&A S.A.S',
  nit: '901.458.283-2',
  domicilio: 'CARRERA 65C # 72-140 – Bello, Antioquia',
  plataforma: 'INDESOFT GPS',
  correo: 'comercial@indesoftsas.com',
  firmante: {
    nombre: 'FLOR ELENA ALVAREZ SEPULVEDA',
    cargo: 'GERENTE GENERAL',
    empresa: 'INGENIERIA Y DESARROLLO DE SOFTWARE A&A S.A.S',
    telefono: 'CL: 350 555 6187',
  },
  //pie: '(+57) 350 555 6187   info@indesoftsas.com   www.indesoftsas.com',
};

const FUENTE = 10;
const LINE = 4.9;
const MARGEN_IZQ = 20;
const MARGEN_INFERIOR = 24;

interface Segmento {
  t: string;
  b?: boolean;
}

interface Ctx {
  doc: jsPDF;
  y: number;
  x: number;
  w: number;
  pageW: number;
  pageH: number;
}

interface VehiculoGps {
  id: number | string;
  name: string;
}

/** Datos de un vehículo verificado, usados para el PDF */
interface VehiculoCertificado {
  placa: string;
  marca?: string | null;
  modelo?: number | string | null;
}

/** Resultado de verificar una placa */
interface ResultadoVerificacion {
  placa: string;
  estado: 'ok' | 'no_existe' | 'inactiva' | 'error';
  data?: VehiculoCertificado;
  mensaje?: string;
}

@Component({
  selector: 'app-certificados-gps',
  templateUrl: './certificados-gps.component.html',
  styleUrls: ['./certificados-gps.component.scss'],
})
export class CertificadosGpsComponent implements OnInit {
  vehiculos: VehiculoGps[] = [];
  placasSeleccionadas: string[] = [];

  cargandoVehiculos = false;
  generando = false;
  progreso = '';

  administraciones: any[] = [];

  constructor(
    private gpsService: GpsService,
    private vehiclesService: VehiclesService,
    private gpcGoogle: gpcGoogleService,
    private administracionesServices: AdministracionService,
    private loadingService: AdminSeafLoadingService
  ) {}

  ngOnInit(): void {
     this.loadingService.mostrar("Consultando unidades",[],"Conectado al servidor GPS...")
    this.cargarVehiculos();

    this.cargarDataAdmin();
  }

  // ============================================================
  // Carga de datos
  // ============================================================
 
cargarVehiculos(): void {
  this.cargandoVehiculos = true;

  this.gpsService.getDevices().subscribe({
    next: (response) => {
      try {
        const unicos = new Map<string, VehiculoGps>();

        if (Array.isArray(response?.data)) {
          for (const grupo of response.data) {
            if (!Array.isArray(grupo?.items)) {
              continue;
            }

            for (const v of grupo.items) {
              const id = v?.id;
              const name = String(v?.name ?? '')
                .trim()
                .toUpperCase();

              // Ignorar vehículos sin identificador o nombre
              if (
                id === null ||
                id === undefined ||
                name.length === 0
              ) {
                continue;
              }

              // Evitar duplicados por nombre de placa
              if (!unicos.has(name)) {
                unicos.set(name, {
                  id,
                  name
                });
              }
            }
          }
        }

        this.vehiculos = Array.from(unicos.values())
          .sort((a, b) =>
            a.name.localeCompare(b.name, 'es-CO', {
              numeric: true,
              sensitivity: 'base'
            })
          );

        // Eliminar de la selección las placas que ya no están disponibles
        const disponibles = new Set(
          this.vehiculos.map(v => v.name)
        );

        this.placasSeleccionadas = (
          this.placasSeleccionadas ?? []
        ).filter((placa: string) => disponibles.has(placa));
          this.loadingService.ocultar();
      } catch (error) {
        console.error('Error al procesar vehículos GPS:', error);

        this.vehiculos = [];

        Swal.fire({
          icon: 'error',
          title: 'Error al procesar vehículos',
          text: 'No fue posible procesar la lista de vehículos GPS.',
          confirmButtonColor: '#7161ff'
        });
      } finally {
        this.cargandoVehiculos = false;
      }
    },

    error: (error) => {
      this.cargandoVehiculos = false;

      console.error('Error al cargar vehículos GPS:', error);

      Swal.fire({
        icon: 'error',
        title: 'Error al cargar vehículos',
        text: 'No se pudieron consultar los vehículos GPS. Intenta nuevamente.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#7161ff'
      });
    }
  });
}


  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => (this.administraciones = data ?? []),
      error: (err) => console.error('Error al cargar datos de la administración:', err),
    });
  }

  // ============================================================
  // Flujo principal: verificar placas una a una → generar un solo PDF
  // ============================================================
  async generarCertificado(): Promise<void> {
    if (!this.placasSeleccionadas?.length) {
      Swal.fire('Atención', 'Selecciona al menos una placa para generar el certificado.', 'warning');
      return;
    }
    if (!this.administraciones.length) {
      Swal.fire('Atención', 'Aún no se han cargado los datos de la empresa. Intenta de nuevo.', 'warning');
      return;
    }

    // Placas normalizadas y sin repetir
    const placas = Array.from(new Set(this.placasSeleccionadas.map((p) => p.trim().toUpperCase())));

    this.generando = true;
    try {
      // 1) Verificar una por una
      const resultados: ResultadoVerificacion[] = [];
      for (let i = 0; i < placas.length; i++) {
        this.progreso = `Verificando ${i + 1} de ${placas.length}: ${placas[i]}`;
        resultados.push(await this.verificarPlaca(placas[i]));
      }

      // 2) Si alguna falla, se informa y no se genera el certificado
      const fallidas = resultados.filter((r) => r.estado !== 'ok');
      if (fallidas.length) {
        this.mostrarFallidas(fallidas);
        return;
      }

      // 3) Todas válidas: un solo certificado
      this.progreso = 'Generando certificado...';
      const vehiculos = resultados.map((r) => r.data as VehiculoCertificado);
      const blob = await this.crearPdf(vehiculos);
      const nombre =
        vehiculos.length === 1
          ? `CERTIFICADO GPS - ${vehiculos[0].placa}.pdf`
          : `CERTIFICADO GPS - ${vehiculos.length} VEHICULOS.pdf`;
      this.abrirPdf(blob, nombre);
    } catch (e: any) {
      if (e?.message === 'FIRMA_NO_DISPONIBLE') {
        Swal.fire(
          'Firma no disponible',
          'No se pudo cargar la firma del representante legal. Verifica que tenga una firma activa.',
          'error'
        );
      } else {
        console.error('Error generando el certificado:', e);
        Swal.fire('Error', 'No se pudo generar el certificado.', 'error');
      }
    } finally {
      this.generando = false;
      this.progreso = '';
    }
  }

  /** Verifica una placa contra la plataforma; nunca lanza error, devuelve el estado */
  private async verificarPlaca(placa: string): Promise<ResultadoVerificacion> {
    try {
      const res: any = await this.vehiclesService.getVerificarPlaca(placa).toPromise();
      if (!res?.existe) {
        return { placa, estado: 'no_existe' };
      }
      if (!res?.activo) {
        return { placa, estado: 'inactiva' };
      }
      return {
        placa,
        estado: 'ok',
        data: { placa: res.placa ?? placa, marca: res.marca, modelo: res.modelo },
      };
    } catch (err: any) {
      return {
        placa,
        estado: 'error',
        mensaje: err?.error?.message || err?.message || 'No se pudo verificar',
      };
    }
  }

  /** Informa (centrado) las placas que no tienen servicio GPS (no existen o están inactivas) y las que no se pudieron verificar */
  private mostrarFallidas(fallidas: ResultadoVerificacion[]): void {
    const sinServicio = fallidas.filter((f) => f.estado === 'no_existe' || f.estado === 'inactiva');
    const conError = fallidas.filter((f) => f.estado === 'error');

    const lineasSinServicio = sinServicio
      .map((f) => `<p class="mb-1">La placa <strong>${f.placa}</strong> no cuenta con servicio GPS con Indesoft</p>`)
      .join('');

    const lineasError = conError
      .map(
        (f) =>
          `<p class="mb-1">No se pudo verificar la placa <strong>${f.placa}</strong>` +
          `${f.mensaje ? ` <small>(${f.mensaje})</small>` : ''}</p>`
      )
      .join('');

    const html =
      `<div class="text-center">` +
      lineasSinServicio +
      (lineasError ? `<div class="${lineasSinServicio ? 'mt-3' : ''}">${lineasError}</div>` : '') +
      `<p class="mt-3 mb-0"><small>Retira estas placas de la selección para generar el certificado.</small></p>` +
      `</div>`;

    Swal.fire({
      icon: 'info',
      title: 'No se generó el certificado',
      html,
    });
  }

  /** Abre el PDF en otra pestaña; si el navegador bloquea la ventana, lo descarga */
  private abrirPdf(blob: Blob, nombre: string): void {
    const url = URL.createObjectURL(blob);
    const ventana = window.open(url, '_blank');
    if (!ventana) {
      const enlace = document.createElement('a');
      enlace.href = url;
      enlace.download = nombre;
      enlace.click();
    }
  }

  // ============================================================
  // Imágenes
  // ============================================================
  /** Descarga una imagen del bucket en base64 (null si no existe o falla) */
  private async cargarImagenBase64(path: string): Promise<string | null> {
    if (!path) return null;
    try {
      const res: any = await this.gpcGoogle.getSignedUrl(path).toPromise();
      if (!res?.url) return null;
      return (await this.gpcGoogle.getImageBase64(res.url)) || null;
    } catch {
      return null;
    }
  }

  /** Lee una imagen de assets en base64 (null si no existe) */
  private async cargarAssetBase64(url: string): Promise<string | null> {
    try {
      const resp = await fetch(url);
      const tipo = resp.headers.get('content-type') ?? '';
      if (!resp.ok || !tipo.startsWith('image/')) return null;
      const blob = await resp.blob();
      return await new Promise<string | null>((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(typeof reader.result === 'string' ? reader.result : null);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  }

  /** Imagen de la carpeta de la empresa en assets; si no está, intenta el bucket (opcional) */
  private async cargarImagenEmpresa(
    nit: string | number | undefined,
    archivo: string,
    rutaBucket?: string
  ): Promise<string | null> {
    if (nit) {
      const local = await this.cargarAssetBase64(rutaAsset(nit, archivo));
      if (local) return local;
    }
    return rutaBucket ? this.cargarImagenBase64(rutaBucket) : null;
  }

  /** Logo de la empresa: primero assets locales, luego el bucket */
  
  /** Firma del firmante: primero assets/images/logos/{NIT_FIRMA}/firma.png, luego el bucket */
  private async cargarFirmaActiva(): Promise<string | null> {
    try {
      return await this.cargarImagenEmpresa(NIT_FIRMA, 'firma.png', `${NIT_FIRMA}/logos/firma.png`);
    } catch (e) {
      console.error('Error cargando la firma:', e);
      return null;
    }
  }

  private formatoImagen(dataUrl: string): 'PNG' | 'JPEG' {
    return /^data:image\/jpe?g/i.test(dataUrl) ? 'JPEG' : 'PNG';
  }

  /** Calcula el tamaño que cabe en maxW x maxH manteniendo la proporción de la imagen */
  private ajustarImagen(doc: jsPDF, img: string, maxW: number, maxH: number): { w: number; h: number } {
    try {
      const props = doc.getImageProperties(img);
      const proporcion = props.width / props.height;
      let w = maxW;
      let h = w / proporcion;
      if (h > maxH) {
        h = maxH;
        w = h * proporcion;
      }
      return { w, h };
    } catch {
      return { w: maxW, h: maxH };
    }
  }

  // ============================================================
  // Construcción del PDF
  // ============================================================
  private async crearPdf(vehiculos: VehiculoCertificado[]): Promise<Blob> {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter', compress: true });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const varios = vehiculos.length > 1;


    //agregar imagen de fondo que que la hoja membrete



    // Datos de la empresa (administración)
    const adm: any = this.administraciones[0] ?? {};
    const nit = adm.nit;
    const empresa = String(adm.empresa ?? adm.nombre ?? adm.razonSocial ?? '').toUpperCase();

    // Imágenes (logo, MinTIC y sello son opcionales; la firma depende de FIRMA_OBLIGATORIA)
    const [ mintic, sello, firma, fondo] = await Promise.all([
      //this.cargarImagenEmpresa("901458283", 'logo.png', `901458283/logos/logo.png`),
      this.cargarImagenEmpresa("901458283", ARCHIVO_MINTIC),
      this.cargarImagenEmpresa("901458283", ARCHIVO_SELLO),
      this.cargarFirmaActiva(),
      this.cargarImagenEmpresa("901458283", 'fondo.jpg', `901458283/logos/fondo.jpg`)
    ]);

    if (!firma && FIRMA_OBLIGATORIA) {
      throw new Error('FIRMA_NO_DISPONIBLE');
    }

    const ctx: Ctx = { doc, y: 0, x: MARGEN_IZQ, w: pageW - MARGEN_IZQ * 2, pageW, pageH };

    if (fondo){
      // 
      doc.addImage(fondo, this.formatoImagen(fondo), 0, 0, pageW, pageH, undefined, 'FAST');
    }
    // Logo
   /*  if (logo) {
      const dim = adm.dimensionLogo ?? {};
      const proporcion = Number(dim.w) > 0 && Number(dim.h) > 0 ? Number(dim.w) / Number(dim.h) : 3.2;
      const w = Math.min(55, 24 * proporcion);
      const h = w / proporcion;
      doc.addImage(logo, this.formatoImagen(logo), 14, 8, w, h, undefined, 'FAST');
    } */
    ctx.y = 38;

    // Título
    doc.setFont('helvetica', 'bold').setFontSize(14).setTextColor(0);
    doc.text('CERTIFICACIÓN DE SERVICIO DE MONITOREO SATELITAL GPS', pageW / 2, ctx.y, { align: 'center' });
    ctx.y += 10;

    // Presentación
    this.parrafo(ctx, [
      { t: EMISOR.razonSocial, b: true },
      { t: ', con NIT ' },
      { t: EMISOR.nit, b: true },
      { t: ', con domicilio en la ' },
      { t: EMISOR.domicilio, b: true },
      { t: ', Certifica que la empresa: ' },
      { t: `${empresa},`, b: true },
      { t: ' identificada con NIT. ' },
      { t: String(nit ?? ''), b: true },
      {
        t: varios
          ? ', posee activo el servicio de monitoreo satelital en los siguientes vehículos:'
          : ', posee activo el servicio de monitoreo satelital el siguiente vehículo:',
      },
    ]);

    // Tabla de vehículos (una fila por vehículo)
    this.tablaVehiculos(
      ctx,
      vehiculos.map((v) => [
        String(v.placa ?? 'N/A').toUpperCase(),
        String(v.marca ?? 'N/A').toUpperCase(),
        String(v.modelo ?? 'N/A'),
      ])
    );

    // Descripción del servicio
    this.parrafo(ctx, [
      {
        t:
          'Este servicio se realiza a través de un dispositivo de monitoreo GPS que forma parte de un sistema ' +
          'inteligente tecnológico en línea, diseñado para la gestión eficiente de datos.',
      },
    ]);

    this.parrafo(ctx, [
      {
        t: varios
          ? `Cada vehículo cuenta con un dispositivo GPS conectado a la plataforma de monitoreo satelital ` +
            `${EMISOR.plataforma}, que permite consultar su ubicación y hacer seguimiento a su operación en línea. `
          : `El vehículo cuenta con un dispositivo GPS conectado a la plataforma de monitoreo satelital ` +
            `${EMISOR.plataforma}, que permite consultar su ubicación y hacer seguimiento a su operación en línea. `,
      },
      {
        t:
          `El servicio dispone de monitoreo 24 horas al día, los 7 días de la semana (24/7), y acceso desde plataforma web y las ` +
          `aplicaciones móviles ${EMISOR.plataforma} disponibles para dispositivos Android y iOS.`,
      },
    ]);

    // Características
   /*  this.parrafo(
      ctx,
      [
        { t: '* Ubicación y seguimiento en tiempo real:', b: true },
         {
          t: varios
            ? ' Consulta de la ubicación de los vehículos y seguimiento de sus desplazamientos.'
            : ' Consulta de la ubicación del vehículo y seguimiento de sus desplazamientos.',
        }, 
      ],
      { gap: 2.5 }
    );
    this.parrafo(
      ctx,
      [
        { t: '* Alertas y notificaciones:', b: true },
         {
          t: varios
            ? ' Recepción de avisos relacionados con eventos relevantes de los vehículos.'
            : ' Recepción de avisos relacionados con eventos relevantes del vehículo.',
        }, 
      ],
      { gap: 2.5 }
    ); */
   /*  this.parrafo(
      ctx,
      [
        { t: ' * Alerta por desconexión de batería o alimentación:', b: true },
        {
          t:
            ' Notificación cuando el equipo detecta una interrupción de su alimentación eléctrica, ' +
            'de acuerdo con las capacidades del dispositivo instalado.',
        },
      ],
      { gap: 2.5 }
    ); */
  /*   this.parrafo(ctx, [
      { t: '* Historial de recorridos:', b: true },
      {
        t:
          ' Consulta de los trayectos registrados por la plataforma, según la disponibilidad de información ' +
          'del servicio.',
      },
    ]); */

    // Contacto y fecha
    this.parrafo(ctx, [
      {
        t:
          'En caso de presentarse alguna pregunta, inquietud o requerimiento adicional relacionado con esta ' +
          `información, no dude en comunicarse con nosotros a través del correo electrónico: ${EMISOR.correo}`,
      },
    ]);

    this.parrafo(ctx, [{ t: `Esta certificación se expide a solicitud del interesado ${this.fechaExpedicion()}.` }], {
      justify: false,
    });

    this.parrafo(ctx, [{ t: 'Cordialmente,' }], { justify: false, gap: 2 });

    // Firma, sello y Registro TIC
    this.bloqueFirma(ctx, firma, sello, mintic);

    // Pie simple
    const total = doc.getNumberOfPages();
    for (let i = 1; i <= total; i++) {
      doc.setPage(i);
      doc.setFont('helvetica', 'normal').setFontSize(8).setTextColor(100);
      //doc.text(EMISOR.pie, pageW / 2, pageH - 8, { align: 'center' });
    }

    return doc.output('blob');
  }

  /** "a los 22 días del mes de octubre de 2026" */
  private fechaExpedicion(): string {
    const hoy = new Date();
    const dia = hoy.getDate();
    const mes = hoy.toLocaleDateString('es-CO', { month: 'long' });
    const prefijo = dia === 1 ? 'al día 1 del mes de' : `a los ${dia} días del mes de`;
    return `${prefijo} ${mes} de ${hoy.getFullYear()}`;
  }

  // ---------- Páginas ----------
  private asegurarEspacio(ctx: Ctx, alto: number): void {
    if (ctx.y + alto > ctx.pageH - MARGEN_INFERIOR) {
      ctx.doc.addPage();
      ctx.y = 25;
    }
  }

  // ---------- Párrafos con partes en negrilla y texto justificado ----------
  /** Separa los segmentos en palabras; una palabra puede mezclar normal y negrilla (ej. "NIT." + "#nit") */
  private tokenizar(segmentos: Segmento[]): Segmento[][] {
    const palabras: Segmento[][] = [];
    let actual: Segmento[] = [];
    for (const s of segmentos) {
      for (const parte of s.t.split(/(\s+)/)) {
        if (!parte) continue;
        if (/^\s+$/.test(parte)) {
          if (actual.length) {
            palabras.push(actual);
            actual = [];
          }
        } else {
          actual.push({ t: parte, b: s.b });
        }
      }
    }
    if (actual.length) palabras.push(actual);
    return palabras;
  }

  private parrafo(ctx: Ctx, segmentos: Segmento[], opciones: { justify?: boolean; gap?: number } = {}): void {
    const { justify = true, gap = 4 } = opciones;
    const { doc } = ctx;

    doc.setFontSize(FUENTE).setTextColor(0);
    doc.setFont('helvetica', 'normal');
    const anchoEspacio = doc.getTextWidth(' ');

    // Medir cada palabra
    const palabras = this.tokenizar(segmentos).map((partes) => {
      const medidas = partes.map((p) => {
        doc.setFont('helvetica', p.b ? 'bold' : 'normal');
        return { ...p, ancho: doc.getTextWidth(p.t) };
      });
      return { partes: medidas, ancho: medidas.reduce((s, p) => s + p.ancho, 0) };
    });

    // Armar líneas
    type Palabra = (typeof palabras)[number];
    const lineas: Palabra[][] = [];
    let actual: Palabra[] = [];
    let anchoActual = 0;
    for (const p of palabras) {
      if (actual.length && anchoActual + anchoEspacio + p.ancho > ctx.w) {
        lineas.push(actual);
        actual = [p];
        anchoActual = p.ancho;
      } else {
        anchoActual += (actual.length ? anchoEspacio : 0) + p.ancho;
        actual.push(p);
      }
    }
    if (actual.length) lineas.push(actual);

    // Dibujar
    lineas.forEach((linea, i) => {
      this.asegurarEspacio(ctx, LINE);
      doc.setFontSize(FUENTE).setTextColor(0);

      const suma = linea.reduce((s, p) => s + p.ancho, 0);
      const huecos = linea.length - 1;
      const esUltima = i === lineas.length - 1;
      const espacio = justify && !esUltima && huecos > 0 ? (ctx.w - suma) / huecos : anchoEspacio;

      let x = ctx.x;
      linea.forEach((palabra) => {
        palabra.partes.forEach((parte) => {
          doc.setFont('helvetica', parte.b ? 'bold' : 'normal');
          doc.text(parte.t, x, ctx.y);
          x += parte.ancho;
        });
        x += espacio;
      });
      ctx.y += LINE;
    });

    ctx.y += gap;
  }

  // ---------- Tabla PLACA | MARCA | MODELO (una fila por vehículo) ----------
  private tablaVehiculos(ctx: Ctx, filas: string[][]): void {
    const { doc } = ctx;
    const alto = 6.5;
    const ancho = ctx.w / 3;
    const titulos = ['PLACA', 'MARCA', 'MODELO'];

    const dibujarEncabezado = (): void => {
      doc.setDrawColor(0).setLineWidth(0.3).setTextColor(0).setFontSize(FUENTE);
      titulos.forEach((titulo, i) => {
        const x = ctx.x + i * ancho;
        doc.setFillColor(217, 217, 217);
        doc.rect(x, ctx.y, ancho, alto, 'FD');
        doc.setFont('helvetica', 'bold');
        doc.text(titulo, x + ancho / 2, ctx.y + 4.6, { align: 'center' });
      });
      ctx.y += alto;
    };

    // Encabezado + al menos una fila juntos
    this.asegurarEspacio(ctx, alto * 2 + 8);
    ctx.y -= 2;
    dibujarEncabezado();

    filas.forEach((valores) => {
      // Si la fila no cabe, nueva página y se repite el encabezado
      if (ctx.y + alto > ctx.pageH - MARGEN_INFERIOR) {
        doc.addPage();
        ctx.y = 25;
        dibujarEncabezado();
      }

      doc.setDrawColor(0).setLineWidth(0.3).setTextColor(0).setFontSize(FUENTE);
      doc.setFont('helvetica', 'normal');
      valores.forEach((valor, i) => {
        const x = ctx.x + i * ancho;
        doc.rect(x, ctx.y, ancho, alto);
        doc.text(valor, x + ancho / 2, ctx.y + 4.6, { align: 'center', maxWidth: ancho - 4 });
      });
      ctx.y += alto;
    });

    ctx.y += 8;
  }

  // ---------- Firma, sello, datos del firmante y Registro TIC ----------
  private bloqueFirma(ctx: Ctx, firma: string | null, sello: string | null, mintic: string | null): void {
    const { doc } = ctx;
    const f = EMISOR.firmante;

    this.asegurarEspacio(ctx, 40);
    const yInicio = ctx.y;

    // Imagen de la firma sobre el nombre
    if (firma) {
      doc.addImage(firma, this.formatoImagen(firma), ctx.x, yInicio + 6, 22, 22, undefined, 'FAST');
    }

    // Sello: junto a la firma, por debajo del texto para que los datos sigan legibles
    if (sello) {
      const { w, h } = this.ajustarImagen(doc, sello, SELLO.maxW, SELLO.maxH);
      doc.addImage(sello, this.formatoImagen(sello), ctx.x + SELLO.dx, yInicio + SELLO.dy, w, h, undefined, 'FAST');
    }

    // Datos del firmante
    let y = yInicio + 24;
    doc.setFontSize(FUENTE).setTextColor(0);
    doc.setFont('helvetica', 'normal');
    y += 4.8;
    doc.text(f.nombre, ctx.x, y);
    y += 4.8;
    doc.text(f.cargo, ctx.x, y);
    y += 4.8;
    doc.text(f.empresa, ctx.x, y);
    y += 4.8;
    doc.text(f.telefono, ctx.x, y);

    // Registro Único de TIC (columna derecha)
    const xDerecha = ctx.x + ctx.w * 0.6;
    doc.text('Registro Único de TIC N°:', xDerecha+10, yInicio + 24);
    if (mintic) {
      const { w, h } = this.ajustarImagen(doc, mintic, 55, 12);
      doc.addImage(mintic, this.formatoImagen(mintic), xDerecha+10, yInicio + 28, w, h, undefined, 'FAST');
    }

    ctx.y = y + 6;
  }
}